<clr-side-panel [(clrSidePanelOpen)]="opened" [clrSidePanelStaticBackdrop]="true">
  <h3 class="side-panel-title">{{ 'Dashboard Einstellungen' | mrTranslate }}</h3>
  <div class="side-panel-body">
    <clr-stack-view [formGroup]="optGroup" style="margin-top: 5px">
      <clr-stack-block [clrSbExpanded]="true">
        <clr-stack-label>{{ 'Zustand' | mrTranslate }}</clr-stack-label>

        <clr-stack-block>
          <clr-stack-label>{{ 'Betriebsgefahr' | mrTranslate }}</clr-stack-label>
          <clr-stack-content>
            <input type="checkbox" clrCheckbox formControlName="show_BG" />
          </clr-stack-content>
        </clr-stack-block>

        <clr-stack-block>
          <clr-stack-label>{{ 'Störungen' | mrTranslate }}</clr-stack-label>
          <clr-stack-content>
            <input type="checkbox" clrCheckbox formControlName="show_Stoer" />
          </clr-stack-content>
        </clr-stack-block>

        <clr-stack-block>
          <clr-stack-label>{{ 'Sperrungen' | mrTranslate }}</clr-stack-label>
          <clr-stack-content>
            <input type="checkbox" clrCheckbox formControlName="show_Sperr" />
          </clr-stack-content>
        </clr-stack-block>

        <clr-stack-block>
          <clr-stack-label>{{ 'Langsamfahrstellen' | mrTranslate }}</clr-stack-label>
          <clr-stack-content>
            <input type="checkbox" clrCheckbox formControlName="show_LF" />
          </clr-stack-content>
        </clr-stack-block>

        <clr-stack-block>
          <clr-stack-label>{{ 'Sonderinspektion' | mrTranslate }}</clr-stack-label>
          <clr-stack-content>
            <input type="checkbox" clrCheckbox formControlName="show_Sonder" />
          </clr-stack-content>
        </clr-stack-block>
      </clr-stack-block>

      <clr-stack-block [clrSbExpanded]="true">
        <clr-stack-label>{{ 'Termine überschritten' | mrTranslate }}</clr-stack-label>

        <clr-stack-block>
          <clr-stack-label>{{ 'Inspektion' | mrTranslate }}</clr-stack-label>
          <clr-stack-content>
            <input type="checkbox" clrCheckbox formControlName="show_Anz_Insp" />
          </clr-stack-content>
        </clr-stack-block>

        <clr-stack-block>
          <clr-stack-label>{{ 'Auftrag' | mrTranslate }}</clr-stack-label>
          <clr-stack-content>
            <input type="checkbox" clrCheckbox formControlName="show_Anz_Auf" />
          </clr-stack-content>
        </clr-stack-block>

        <clr-stack-block>
          <clr-stack-label>{{ 'Begehung' | mrTranslate }}</clr-stack-label>
          <clr-stack-content>
            <input type="checkbox" clrCheckbox formControlName="show_Anz_Begeh" />
          </clr-stack-content>
        </clr-stack-block>

        <clr-stack-block>
          <clr-stack-label>{{ 'Wartung' | mrTranslate }}</clr-stack-label>
          <clr-stack-content>
            <input type="checkbox" clrCheckbox formControlName="show_Anz_Wart" />
          </clr-stack-content>
        </clr-stack-block>

        @if (optChecked_EBL == 1) {
          <clr-stack-block>
            <clr-stack-label>{{ 'durch ALV bestätigen' | mrTranslate }}</clr-stack-label>
            <clr-stack-content>
              <input type="checkbox" clrCheckbox formControlName="show_Anz_ALV" />
            </clr-stack-content>
          </clr-stack-block>
        }

        @if (optChecked_EBL == 1) {
          <clr-stack-block>
            <clr-stack-label>{{ 'durch EBL bestätigen' | mrTranslate }}</clr-stack-label>
            <clr-stack-content>
              <input type="checkbox" clrCheckbox formControlName="show_Anz_EBL" />
            </clr-stack-content>
          </clr-stack-block>
        }

        <clr-stack-block>
          <clr-stack-label>{{ 'Sonderinspektion' | mrTranslate }}</clr-stack-label>
          <clr-stack-content>
            <input type="checkbox" clrCheckbox formControlName="show_Anz_Sonder" />
          </clr-stack-content>
        </clr-stack-block>
      </clr-stack-block>

      <clr-stack-block [clrSbExpanded]="true">
        <clr-stack-label>{{ 'Diagramme' | mrTranslate }}</clr-stack-label>

        <clr-stack-block>
          <clr-stack-label>{{ 'Fehlerkassen' | mrTranslate }}</clr-stack-label>
          <clr-stack-content>
            <input type="checkbox" clrCheckbox formControlName="show_Dia_FK" />
          </clr-stack-content>
        </clr-stack-block>

        <clr-stack-block>
          <clr-stack-label>{{ 'KAV' | mrTranslate }}</clr-stack-label>
          <clr-stack-content>
            <input type="checkbox" clrCheckbox formControlName="show_Dia_KAV" />
          </clr-stack-content>
        </clr-stack-block>

        <clr-stack-block>
          <clr-stack-label>{{ 'Instandsetzung' | mrTranslate }}</clr-stack-label>
          <clr-stack-content>
            <input type="checkbox" clrCheckbox formControlName="show_Dia_Inst" />
          </clr-stack-content>
        </clr-stack-block>

        <clr-stack-block>
          <clr-stack-label>{{ 'Kosten' | mrTranslate }}</clr-stack-label>
          <clr-stack-content>
            <input type="checkbox" clrCheckbox formControlName="show_Dia_Kost" />
          </clr-stack-content>
        </clr-stack-block>

        <clr-stack-block>
          <clr-stack-label>{{ 'Programmnutzung' | mrTranslate }}</clr-stack-label>
          <clr-stack-content>
            <input type="checkbox" clrCheckbox formControlName="show_Dia_Prog" />
          </clr-stack-content>
        </clr-stack-block>
      </clr-stack-block>
    </clr-stack-view>
  </div>
  <div class="side-panel-footer">
    <button type="button" class="btn btn-outline" (click)="saveOpt()">{{ 'Schließen' | mrTranslate }}</button>
  </div>
</clr-side-panel>

<div class="w-100-p padding-10-lr padding-12-tb" style="position: relative">
  <button class="btn btn-icon" style="position: absolute; top: 5px; right: 5px" (click)="opened = true">
    <cds-icon shape="cog" [title]="'Einstellungen' | mrTranslate" />
  </button>
  <div class="grid gap-5" id="dashboard-grid-container">
    <div class="subgrid span-row">
      <strong class="span-row margin-24-t">{{ 'Zustand' | mrTranslate }}</strong>
      @if (optGroup.controls.show_BG.value  && allowComponents.maengel) {
        <a (click)="routing('/maengel', 'betriebsgefahr')" class="card clickable info-card">
          <div class="card-block">
            <div class="card-title nowrap">
              <cds-icon style="color: red" shape="error-standard" size="28" />
              {{ 'Betriebsgefahr' | mrTranslate }}
            </div>
            <div class="card-text" style="font-size: 25px">
              {{ anzBG }}
            </div>
          </div>
        </a>
      }

      @if (optGroup.controls.show_Stoer.value  && allowComponents.anlagen) {
        <a (click)="routing('/anlagen', 'st')" class="card clickable info-card">
          <div class="card-block">
            <div class="card-title nowrap">
              <cds-icon style="color: red" shape="exclamation-triangle" size="28" />
              {{ 'Störungen' | mrTranslate }}
            </div>
            <div class="card-text" style="font-size: 25px">
              {{ anzStoer }}
            </div>
          </div>
        </a>
      }
      @if (optGroup.controls.show_Sperr.value && allowComponents.anlagen) {
        <a (click)="routing('/anlagen', 'sp')" class="card clickable info-card">
          <div class="card-block">
            <div class="card-title nowrap">
              <cds-icon shape="gesperrt" size="28" />
              {{ 'Sperrungen' | mrTranslate }}
            </div>
            <div class="card-text" style="font-size: 25px">
              {{ anzSperr }}
            </div>
          </div>
        </a>
      }

      @if (optGroup.controls.show_LF.value && allowComponents.anlagen) {
        <a (click)="routing('/anlagen', 'lf')" class="card clickable info-card">
          <div class="card-block">
            <div class="card-title nowrap">
              <cds-icon style="color: orange" shape="lastelle" size="28" />
              {{ 'Langsamfahrstellen' | mrTranslate }}
            </div>
            <p class="card-text" style="font-size: 25px">
              {{ anzLF }}
            </p>
          </div>
        </a>
      }
      @if (optGroup.controls.show_Sonder.value && allowComponents.anlagen) {
        <a (click)="routing('/anlagen', 'si')" class="card clickable info-card">
          <div class="card-block">
            <div class="card-title nowrap">
              <cds-icon style="color: orangered" shape="warning-standard" size="28" />
              {{ 'Sonderinspektion' | mrTranslate }}
            </div>
            <p class="card-text" style="font-size: 25px">
              {{ anzSonder }}
            </p>
          </div>
        </a>
      }
    </div>

    <div class="subgrid span-row">
      <strong class="span-row margin-24-t">{{ 'Termine überschritten' | mrTranslate }}</strong>
      @if (optGroup.controls.show_Anz_Insp.value && allowComponents.anlagen) {
        <a (click)="routing('/anlagen', 'OSTAMMID')" class="card clickable info-card">
          <div class="card-block">
            <div class="card-title">{{ 'Inspektion' | mrTranslate }}</div>
            <p class="card-text" style="font-size: 25px">
              {{ anzInsp }}
            </p>
          </div>
        </a>
      }

      @if (optGroup.controls.show_Anz_Auf.value && allowComponents.auftraege) {
        <a (click)="routing('/auftraege', 'termin')" class="card clickable info-card">
          <div class="card-block">
            <div class="card-title">{{ 'Auftrag' | mrTranslate }}</div>
            <p class="card-text" style="font-size: 25px">
              {{ anzAuf }}
            </p>
          </div>
        </a>
      }

      @if (optGroup.controls.show_Anz_Begeh.value && hasBegeh && allowComponents.begehung) {
        <a (click)="routing('/begehung', 'term')" class="card clickable info-card">
          <div class="card-block">
            <div class="card-title">{{ 'Begehung' | mrTranslate }}</div>
            <p class="card-text" style="font-size: 25px">
              {{ anzBegeh }}
            </p>
          </div>
        </a>
      }
      @if (optGroup.controls.show_Anz_Wart.value && allowComponents.wartung) {
        <a (click)="routing('/wartung', 'term')" class="card clickable info-card">
          <div class="card-block">
            <div class="card-title">{{ 'Wartung' | mrTranslate }}</div>
            <p class="card-text" style="font-size: 25px">
              {{ anzWart }}
            </p>
          </div>
        </a>
      }
      @if (optGroup.controls.show_Anz_Sonder.value && anzSonder !== 0 && allowComponents.anlagen) {
        <a (click)="routing('/anlagen', 'term')" class="card clickable info-card">
          <div class="card-block">
            <div class="card-title">{{ 'Sonderinspektion' | mrTranslate }}</div>
            <p class="card-text" style="font-size: 25px">
              {{ anzSonderTermin }}
            </p>
          </div>
        </a>
      }
      @if (optChecked_EBL == 1 && allowComponents.anlagen) {
        @if (optGroup.controls.show_Anz_ALV.value) {
          <a (click)="routing('/anlagen', 'ALV')" class="card clickable info-card">
            <div class="card-block">
              <div class="card-title">{{ 'durch ALV bestätigen' | mrTranslate }}</div>
              <p class="card-text" style="font-size: 25px">
                {{ anzALV }}
              </p>
            </div>
          </a>
        }
        @if (optGroup.controls.show_Anz_EBL.value && allowComponents.anlagen) {
          <a (click)="routing('/anlagen', 'EBL')" class="card clickable info-card">
            <div class="card-block">
              <div class="card-title">{{ 'durch EBL bestätigen' | mrTranslate }}</div>
              <p class="card-text" style="font-size: 25px">
                {{ anzEBL }}
              </p>
            </div>
          </a>
        }
      }
    </div>

    <div class="subgrid span-row">
      <strong class="span-row margin-24-t">{{ 'Grafik' | mrTranslate }}</strong>

      @if (optGroup.controls.show_Dia_FK.value) {
        <div class="card graph-card">
          <h3 class="card-header">{{ 'Fehlerklassen' | mrTranslate }}</h3>
          <div class="card-block">
            @if (fkstatistic?.length > 0) {
              <app-plotly-plot
                [data]="fkstatistic"
                [layout]="graph.layout"
                [config]="graph.config"
                (plotEl)="fkLegentSub($event)" />
            } @else {
              <div style="min-height: 500px">
                <clr-spinner class="centred" clrMedium />
              </div>
            }
          </div>
        </div>
      }

      @if (optGroup.controls.show_Dia_KAV.value && showkav) {
        <div class="card graph-card">
          <h3 class="card-header d-flex justify-content-between align-items-center">
            {{ kavTitel }}
            <button
              type="button"
              class="btn btn-icon btn-primary btn-sm float-right"
              style="margin-top: -2px"
              aria-label="settings"
              (click)="changeKAVStatus()">
              <cds-icon shape="angle" direction="right" />
            </button>
            <button
              type="button"
              class="btn btn-icon btn-primary btn-sm float-right"
              style="margin-top: -2px"
              aria-label="settings"
              (click)="openKAVDetaildialog()">
              <cds-icon shape="search" />
            </button>
          </h3>
          <div class="card-block">
            @if (curDiagramm().length > 0) {
              <app-plotly-plot
                [className]=""
                [data]="curDiagramm()"
                [layout]="curgraphkav.layout"
                [config]="curgraphkav.config"
                (plotEl)="qiLegentSub($event)"
              ></app-plotly-plot>
            }
          </div>
        </div>
      }

      @if (optGroup.controls.show_Dia_Inst.value) {
        <div class="card graph-card">
          <h3 class="card-header d-flex justify-content-between align-items-center">
            {{ 'Instandsetzungquote pro Fehlerklasse in %' | mrTranslate }}
            <!-- <button type="button" class="btn btn-icon btn-primary btn-sm float-right" style="margin-top: -2px;" aria-label="settings" (click)="changeKostenStatus()">
              <cds-icon shape="angle" direction="right"/>
            </button> -->
          </h3>
          <div class="card-block">
            <ng-container>
              @if (ih_qoute.length > 0) {
                <app-plotly-plot
                  [className]=""
                  [data]="dia_ih_qoute.data"
                  [layout]="dia_ih_qoute.layout"
                  [config]="dia_ih_qoute.config"></app-plotly-plot>
              }
            </ng-container>
          </div>
        </div>

        <div class="card graph-card">
          <h3 class="card-header d-flex justify-content-between align-items-center">
            {{ 'Instandsetzungsdauer pro Fehlerklasse in Tagen' | mrTranslate }}
            <!-- <button type="button" class="btn btn-icon btn-primary btn-sm float-right" style="margin-top: -2px;" aria-label="settings" (click)="changeKostenStatus()">
              <cds-icon shape="angle" direction="right"/>
            </button> -->
          </h3>
          <div class="card-block">
            <ng-container>
              @if (ih_average.length > 0) {
                <app-plotly-plot
                  [className]=""
                  [data]="dia_ih_average.data"
                  [layout]="dia_ih_average.layout"
                  [config]="dia_ih_average.config"></app-plotly-plot>
              }
            </ng-container>
          </div>
        </div>
      }

      @if (optGroup.controls.show_Dia_Kost.value) {
        <div class="card graph-card">
          <h3 class="card-header d-flex justify-content-between align-items-center">
            {{ kostenTitel }}
            <button
              type="button"
              class="btn btn-icon btn-primary btn-sm float-right"
              style="margin-top: -2px"
              aria-label="settings"
              (click)="changeKostenStatus()">
              <cds-icon shape="angle" direction="right" />
            </button>
          </h3>
          <div class="card-block">
            @if (kostenansicht == 0) {
              @if (kostenweek.length > 0) {
                <app-plotly-plot
                  [className]=""
                  [data]="kostenweek"
                  [layout]="graphkostenweek.layout"
                  [config]="graphkostenweek.config"></app-plotly-plot>
              }
            }
            @if (kostenansicht == 1) {
              @if (kostenmonth.length > 0) {
                <app-plotly-plot
                  [className]=""
                  [data]="kostenmonth"
                  [layout]="graphkostenmonth.layout"
                  [config]="graphkostenmonth.config"></app-plotly-plot>
              }
            }
            @if (kostenansicht == 2) {
              @if (kostenyear.length > 0) {
                <app-plotly-plot
                  [className]=""
                  [data]="kostenyear"
                  [layout]="graphkostenyear.layout"
                  [config]="graphkostenyear.config"></app-plotly-plot>
              }
            }
          </div>
        </div>
      }

      @if (optGroup.controls.show_Dia_Prog.value) {
        <div class="card graph-card">
          <h3 class="card-header d-flex justify-content-between align-items-center">
            {{ userTitel }}
            <button
              type="button"
              class="btn btn-icon btn-primary btn-sm float-right"
              style="margin-top: -2px"
              aria-label="settings"
              (click)="changeUserStatus()">
              <cds-icon shape="angle" direction="right" />
            </button>
          </h3>
          <div class="card-block">
            @if (useransicht == 0) {
              @if (userweek.length > 0) {
                <app-plotly-plot
                  [className]=""
                  [data]="userweek"
                  [layout]="graphusernweek.layout"
                  [config]="graphusernweek.config"></app-plotly-plot>
              }
            }
            @if (useransicht == 1) {
              @if (usermonth.length > 0) {
                <app-plotly-plot
                  [className]=""
                  [data]="usermonth"
                  [layout]="graphusermonth.layout"
                  [config]="graphusermonth.config"></app-plotly-plot>
              }
            }
            @if (useransicht == 2) {
              @if (useryear.length > 0) {
                <app-plotly-plot
                  [className]=""
                  [data]="useryear"
                  [layout]="graphuseryear.layout"
                  [config]="graphuseryear.config"></app-plotly-plot>
              }
            }
            <!-- <ng-template #other_content3>
              <div class="card">
                <h3 class="card-header">{{"Fehlerklassen" | mrTranslate}} </h3>
                <div class="card-block">
                  <div class="center" style="min-height: 500px;">
                    <span class="spinner spinner-md">Loading...</span>
                  </div>
                </div>
              </div>
            </ng-template> -->
          </div>
        </div>
      }
    </div>
  </div>
</div>
